import { useAccount, useReadContract } from "wagmi";
import { CONFIG } from "../config";
import { erc20Abi } from "viem";
import type { UserData } from "../types";
import { publicClient } from "../lib/viem";
import { useEffect, useState } from "react";

export function useUserData() {
  const { address } = useAccount();
  const [balance, setBalance] = useState<bigint>(0n);
  const [isLoading, setIsLoading] = useState(true);

  const { data: wagmiBalance } = useReadContract({
    address: CONFIG.GEM_TOKEN as `0x${string}`,
    abi: erc20Abi,
    functionName: "balanceOf",
    args: address ? [address] : undefined,
    query: {
      enabled: Boolean(address),
    },
  });

  useEffect(() => {
    if (wagmiBalance !== undefined) {
      setBalance(wagmiBalance);
      setIsLoading(false);
    } else {
      // If no wallet is connected, we'll just show 0 balance
      setBalance(0n);
      setIsLoading(false);
    }
  }, [wagmiBalance]);

  return {
    data: {
      balance,
      activePools: []
    },
    isLoading
  };
}